<template>
    <div>
        <div class="form-group">
            <label><localized-text localizedKey="Modalità pagamento" text="Modalità pagamento"></localized-text></label>
            <template v-if="readonly">
                <input type="text" class="form-control" v-model="localValue.modalitaPagamento" :readonly="readonly" />
            </template>
            <template v-else>
                <select class="form-control" v-model="localValue.modalitaPagamento" :readonly="readonly">
                    <option value=""></option>
                    <option v-for="(item, i) in modalitaPagamentos" :key="i" :value="item.name">{{item.name}}</option>
                </select>
            </template>
        </div>

        <template v-if="details">

            <template v-if="details.methodType == 'WireTransfer'">
                <div class="lowTitle text-cyan">
                    <localized-text localizedKey="Dati bancari" text="Dati bancari"></localized-text>
                </div>
                <bank-account-data :item="localValue.bankAccountData" :readonly="readonly"></bank-account-data>
            </template>

            <template v-if="details.methodType == 'Email'">
                <div class="lowTitle text-cyan">
                    <localized-text localizedKey="Email" text="Email"></localized-text>
                </div>
                <input type="text" class="form-control" v-model="localValue.paypalEmail" :readonly="readonly" />
            </template>

            <template v-if="details.methodType == 'Crypto'">
                <div class="lowTitle text-cyan">
                    <localized-text localizedKey="Address" text="Address"></localized-text>
                </div>
                <input type="text" class="form-control" v-model="localValue.cryptoAddress" :readonly="readonly" />
            </template>

            <template v-if="details.methodType == 'CardNumber'">
                <div class="lowTitle text-cyan">
                    <localized-text localizedKey="Numero carta" text="Numero carta"></localized-text>
                </div>
                <input type="text" class="form-control" v-model="localValue.revolutNumber" :readonly="readonly" />
            </template>

        </template>

    </div>
</template>

<script lang="ts">
import { Prop } from 'vue-property-decorator';
import * as OM from '@/model';
import * as CONST from '@/const';
import { mixins, Options, Vue } from 'vue-class-component';
import WithModel from '@/mixins/withModel';
import { ProjectConfigClient } from '@/services/Services';

@Options({})
export default class userPaymentData extends mixins(WithModel) {

    @Prop() readonly: boolean;

    declare localValue: OM.UserPaymentData;

    modalitaPagamentos: OM.PaymentRequestMethodDetails[] = [];

    created(){
        ProjectConfigClient.getPaymentRequestMethods()
        .then(x => {
            this.modalitaPagamentos = x;
        })
    }

    get details(){
        return this.modalitaPagamentos.find(x => x.name == this.localValue.modalitaPagamento);
    }

}
</script>
<style scoped>
</style>
